import { FIELD_UPDATE_SUCCESS } from '.'

const fieldUpdateSuccessAction = (payload) => ({
  type: FIELD_UPDATE_SUCCESS,
  payload
})

export { fieldUpdateSuccessAction }
